import { __module as objectWithoutPropertiesLoose } from '../../../../_virtual/objectWithoutPropertiesLoose.js';

(function (module) {
	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (e.includes(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (objectWithoutPropertiesLoose));
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
